import { useAuthContext } from '../../auth/AuthenticationProvider';
import { useAuditMetaContext } from '../../context/AuditMetaContext';
import { ControlledObservationFormFields as ControlledField } from "../../utils/observation.helpers";
import { IAuditNoteFormData } from '../../interfaces/IAuditNote';


export type UseInitialNoteDataHook = (confs: { key: string, fieldTitle: string }) => IAuditNoteFormData;

export const useInitialNoteData: UseInitialNoteDataHook = (confs) => {

    const { user, anonymousSession } = useAuthContext();
    const { metaData } = useAuditMetaContext();

    const data: IAuditNoteFormData = {
        [ControlledField.informer]: user?.fullname,
        [ControlledField.target]: metaData.target,
        [ControlledField.eventTime]: new Date().toISOString(),


        key: confs.key,
        fieldTitle: confs.fieldTitle,
        makeObservation: false,

        target: metaData.target,
        // creator: user?.hprPersonId
    };

    return data
};
